import React from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import Badge from './Badge';
import {BADGE_COLORS} from '../constants';

const DisplayBoolean = props => {
  const {bool, t} = props;
  return bool ? <Badge color={BADGE_COLORS.GREEN}>{t('dataTable.yes')}</Badge> : <Badge color={BADGE_COLORS.GREY}>{t('dataTable.no')}</Badge>;
};

DisplayBoolean.propTypes = {
  bool: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(DisplayBoolean);
